import * as R from 'ramda';

export default function PRReportPackageSummaryController(
  $q,
  $rootScope,
  $scope,
  loaderService,
  reportsDataService,
  alerts,
  confirmDialog,
  editPackageSummaryDialog,
  ssDialogService,
) {
  const vm = this;

  vm.isExpanded = false;
  vm.hasData = false;

  vm.canGeneratePackage = false;

  vm.handleExpand = _handleExpand;

  vm.handleEditPackage = _handleEditPackage;
  vm.handleGeneratePackage = _handleGeneratePackage;
  vm.handleDeletePackage = _handleDeletePackage;

  vm.documentAttached = _documentAttached;

  _activate();

  _initEventListeners();

  /** ********************************************
   * Event Handlers
   */

  function _handleExpand() {
    if (vm.hasData) {
      vm.isExpanded = !vm.isExpanded;
    } else {
      loaderService.showViewLoader = false;
      vm.isExpanded = !vm.isExpanded;
      vm.hasData = true;
    }
  }

  function _handleEditPackage($event) {
    ssDialogService.dialogs.reports.editPackageSummaryDialog = ssDialogService.alert(
      editPackageSummaryDialog.getOptions($event, {
        reportPackage: vm.reportPackage,
        attachCallback: vm.documentAttached,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.editPackageSummaryDialog);
  }

  function _handleGeneratePackage() {
    return reportsDataService
      .createPackageFileGenerationRequest(vm.reportPackage.reportPackageConfiguration.reportPackageId)
      .then(response => {
        alerts.success(
          'The Report Package has been successfully requested. ' +
            'You will receive an email notification when the file generation is complete.',
        );
        $rootScope.$broadcast('generatePackageQueued', {
          reportPackageId: vm.reportPackage.reportPackageConfiguration.reportPackageId,
        });
      });
  }

  function _handleDeletePackage($event) {
    return _showDeleteDialog($event, {
      dialogTitle: 'Delete Report Package?',
      message: `Are you sure you want to delete Report Package "${vm.reportPackage.reportPackageConfiguration.packageName}"?`,
      handleYesClick: handleConfirmDelete,
      handleNoClick: closeDeleteDialog,
    });
  }

  /** ********************************************
   * Private Functions
   */

  function _activate() {    
    let _canGenerate = true;
    angular.forEach(vm.reportPackage.reportPackageConfiguration.attachedReports, (report) => {
      if (!report.allParametersHaveSubmittedParameters) {
        _canGenerate = false;
      }
    });

    vm.canGeneratePackage = _canGenerate;
  }

  function _initEventListeners() {
    $scope.$on('reports.reportPackageSummaryUpdated', (event, opt) => {
      if (opt.reportPackageId === vm.reportPackage.reportPackageConfiguration.reportPackageId) {
        _refreshReportAttachments();
      }
    });

    $scope.$on('generatedPackageDeleted', (event, opt) => {
      if (vm.reportPackage.reportPackageExecutions !== null && vm.reportPackage.reportPackageExecutions !== undefined) {
        R.forEach(item => {
          if (opt.reportPackageGenerationQueueId === item.reportPackageGenerationQueueId) {
            _refreshGeneratedPackages();
          }
        }, vm.reportPackage.reportPackageExecutions);
      }
    });
    
    $scope.$on('refreshGenerateReportPackageIndicator', (event, opt) => {
      if (opt.reportPackageId === vm.reportPackage.reportPackageConfiguration.reportPackageId) {
        vm.canGeneratePackage = opt.indicatorValue; 
      }
    });

    $scope.$on('refreshReportPackageSummary', (event, opt) => {
      if (opt.reportPackageId === vm.reportPackage.reportPackageConfiguration.reportPackageId) {
        _refreshCanGeneratePackageIndicator();
      }
    });
  }

  function _documentAttached() {
    $rootScope.$broadcast('refreshReportPackageSummary', {
      reportPackageSummaryId: vm.reportPackage.reportPackageSummaryId,
    });
  }

  function _refreshReportAttachments() {
    const dfdRefresh = $q.defer();

    reportsDataService
      .getPackagedReportAttachments(vm.reportPackage.reportPackageConfiguration.reportPackageId)
      .then(response => {
        vm.reportPackage.reportPackageConfiguration.reportPackageReportInstances = [];
        if (response.data.recordCount > 0) {
          angular.extend(
            vm.reportPackage.reportPackageConfiguration.reportPackageReportInstances,
            response.data.result,
          );
        }

        if (response.data.recordCount !== vm.reportPackage.reportPackageConfiguration.numberOfAttachedReports) {
          vm.reportPackage.reportPackageConfiguration.numberOfAttachedReports = response.data.recordCount;

          if (vm.reportPackage.reportPackageConfiguration.numberOfAttachedReports === 0) {
            vm.isExpanded = false;
          }
        }

        dfdRefresh.resolve();
      });
    return dfdRefresh.promise;
  }

  function _refreshCanGeneratePackageIndicator() {
    const dfdRefresh = $q.defer();

    reportsDataService.getReportPackageParameterSummary(vm.reportPackage.reportPackageConfiguration.reportPackageId).then(response => {
        vm.canGeneratePackage = true;

        R.forEach(item => {
          if (item.savedParameterCount !== item.numParameters) {
            vm.canGeneratePackage = false;
          }
        }, response.data.result);

        dfdRefresh.resolve();
      });
    return dfdRefresh.promise;
  }

  function _refreshGeneratedPackages() {
    const dfdRefresh = $q.defer();

    reportsDataService
      .getGeneratedPackages(vm.reportPackage.reportPackageConfiguration.reportPackageId)
      .then(response => {
        vm.reportPackage.reportPackageExecutions = response.data.result;

        dfdRefresh.resolve();
      });
    return dfdRefresh.promise;
  }

  function _showDeleteDialog($event, locals) {
    ssDialogService.dialogs.reports.deleteReportPackageSummaryConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, locals),
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.deleteReportPackageSummaryConfirmDialog);
  }
  
  function handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return reportsDataService
      .deleteReportPackage(vm.reportPackage.reportPackageConfiguration.reportPackageId)
      .then(() => {
        alerts.success('The Report Package has been deleted successfully.');
        $rootScope.$broadcast('refreshReportPackages');
        return closeDeleteDialog();
      })
      .catch(() => {
        alerts.error('An error occurred while deleting the Report Package.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function closeDeleteDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.reports.deleteReportPackageSummaryConfirmDialog);
  }
}

PRReportPackageSummaryController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'loaderService',
  'reportsDataService',
  'alerts',
  'confirmDialog',
  'editPackageSummaryDialog',
  'ssDialogService',
];
